import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    CircularProgress,
    Typography,
    Grid,
    Box,
    IconButton,
    Avatar
} from '@mui/material';
import { Close as CloseIcon, Person as PersonIcon } from '@mui/icons-material';
import axios from 'axios';

const UserDataPopup = ({ open, onClose, userId }) => {
    const [loading, setLoading] = useState(true);
    const [userData, setUserData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (open && userId) {
            setLoading(true);
            setError(null);
            axios
                .get(`${process.env.REACT_APP_API_BASE_URL}/User/GetOneUserByID?UserID=${userId}`)
                .then((response) => {
                    if (response.data.success) {
                        setUserData(response.data.data);
                    } else {
                        setError('მომხმარებლის მონაცემების მიღება ვერ მოხერხდა');
                    }
                })
                .catch((err) => {
                    setError('მონაცემების მიღების შეცდომა');
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [open, userId]);

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Box display="flex" alignItems="center">
                        <Avatar sx={{ bgcolor: 'primary.main', marginRight: 2 }}>
                            <PersonIcon />
                        </Avatar>
                        <Typography variant="h6">მომხმარებლის მონაცემები</Typography>
                    </Box>
                    <IconButton onClick={onClose} edge="end" aria-label="close">
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent dividers>
                {loading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                        <CircularProgress />
                    </Box>
                ) : error ? (
                    <Typography color="error" align="center">{error}</Typography>
                ) : (
                    userData && (
                        <Grid container spacing={3} sx={{ padding: '16px' }}>
                            {userData.firstName !== " " && (
                                <>
                                    <Grid item xs={12} sm={6}>
                                        <Typography variant="subtitle1"><strong>სახელი:</strong></Typography>
                                        <Typography variant="body1">{userData.firstName || 'მონაცემი არ არის'}</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Typography variant="subtitle1"><strong>გვარი:</strong></Typography>
                                        <Typography variant="body1">{userData.lastName || 'მონაცემი არ არის'}</Typography>
                                    </Grid>
                                </>
                            )}

                            {userData.pNumber && userData.pNumber.length === 11 && (
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle1"><strong>პირადი ნომერი:</strong></Typography>
                                    <Typography variant="body1">{userData.pNumber || 'მონაცემი არ არის'}</Typography>
                                </Grid>
                            )}


                            <Grid item xs={12} sm={6}>
                                <Typography variant="subtitle1"><strong>ელ. ფოსტა:</strong></Typography>
                                <Typography variant="body1">{userData.email || 'მონაცემი არ არის'}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="subtitle1"><strong>ტელეფონი:</strong></Typography>
                                <Typography variant="body1">{userData.phone !== '0' ? userData.phone : 'მონაცემი არ არის'}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="subtitle1"><strong>დაბადების თარიღი:</strong></Typography>
                                <Typography variant="body1">
                                    {userData.birthDate !== '2030-01-01T00:00:00'
                                        ? new Date(userData.birthDate).toLocaleDateString('ka-GE', { day: '2-digit', month: '2-digit', year: 'numeric' })
                                        : 'მონაცემი არ არის'}
                                </Typography>
                            </Grid>

                            {userData.orgName &&
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle1"><strong>ორგანიზაციის სახელი:</strong></Typography>
                                    <Typography variant="body1">{userData.orgName}</Typography>
                                </Grid>
                            }
                            {userData.orgNumber &&
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle1"><strong>ორგანიზაციის საიდენტიფიკაციო კოდი:</strong></Typography>
                                    <Typography variant="body1">{userData.orgNumber}</Typography>
                                </Grid>
                            }
                        </Grid>
                    )
                )}
            </DialogContent>
        </Dialog>
    );
};

export default UserDataPopup;
